import ClearIcon from "@mui/icons-material/Clear";
import { styled } from "@mui/material/styles";
import IconButton from "designSystem/components/button/IconButton";
import Chip from "designSystem/components/chip/Chip";
import { FlexRowCenter, SingleSelect, ToggleButton, ToggleButtonGroup } from "designSystem/index";
import { grey } from "designSystem/styles/color";
import { STANDARD_BORDER_STYLE } from "designSystem/styles/style-functions";
import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { getSortingIcon } from "./CustomViewSortingIcons";
import { SortingLevel, useCustomViewSortingStore } from "./CustomViewSortingStore";

interface SingleRuleGridProps {
	/** sorting level */
	level: SortingLevel;
}

const StyledChip = styled(Chip)(() => ({
	marginLeft: 4,
	marginRight: 8,
}));

const CustomViewSortingLevel: FunctionComponent<SingleRuleGridProps> = observer(({ level }) => {
	const {
		getOptions,
		removeSortingLevel,
		setSortingLevel,
		sortingList,
	} = useCustomViewSortingStore();

	const index = sortingList.indexOf(level);

	if (index === -1) {
		console.warn("CustomViewSortingLevel - level not found");
		return null;
	}

	const {
		descending,
		item,
		setSortingLevelSortOrder,
		valueType,
	} = sortingList[index] || {};

	const AscendingIcon = getSortingIcon(valueType, false);
	const DescendingIcon = getSortingIcon(valueType, true);

	return (
		<FlexRowCenter
			bgcolor={grey[100]}
			data-csi-automation="CustomViewSortingLevel"
			justifyContent="space-between"
			marginY={2}
			pl={4}
			py={2}
			sx={{ border: STANDARD_BORDER_STYLE, borderRadius: 1 }}
		>
			<FlexRowCenter gap={2} growNoOverflow>
				<StyledChip label={index + 1} />
				<SingleSelect
					disableClearable
					forcePopupIcon
					groupBy={(option) => option.group}
					onChange={(event, value, reason) => setSortingLevel(value, index)}
					options={getOptions(item)}
					sx={{ width: 231 }}
					value={item}
				/>
				<ToggleButtonGroup
					exclusive
					onChange={(event, value) => setSortingLevelSortOrder(value)}
					value={descending}
				>
					<ToggleButton
						value={false}
					>	
						<AscendingIcon />
					</ToggleButton>
					<ToggleButton
						value
					>
						<DescendingIcon />
					</ToggleButton>
				</ToggleButtonGroup>
			</FlexRowCenter>
			<FlexRowCenter>
				<IconButton
					onClick={() => removeSortingLevel(index)}
					size="large"
				>
					<ClearIcon />
				</IconButton>
			</FlexRowCenter>
		</FlexRowCenter>
	);
});

export default CustomViewSortingLevel;